interface OwnProfileSource {
  display_name?: unknown
  email?: unknown
  idp?: unknown
  name_is_idp_owned?: unknown
  settable?: unknown
}

/**
 * Normalize `core.my_profile()` without widening its authority. Only the
 * authenticated session may fill a missing login address; ownership and
 * mutability remain the profile door's answer.
 */
export function normalizeOwnProfile(
  row: OwnProfileSource | null | undefined,
  session: { email?: string | null } | null | undefined,
) {
  if (!row) return session ? { email: session.email, settable: [] } : null
  return {
    display_name: row.display_name == null ? null : String(row.display_name),
    email: row.email == null ? (session?.email ?? null) : String(row.email),
    idp: row.idp == null ? null : String(row.idp),
    name_is_idp_owned: row.name_is_idp_owned === true,
    settable: Array.isArray(row.settable) ? (row.settable as string[]) : [],
  }
}
